import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Box, Grid, useTheme } from "@mui/material";
import _ from "lodash";
import Request from "core/requests";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "components/common";
import { getPointStatusFields } from "keplerConfigs/config/homeMap/dataset/stations/status";
import { configMapTheme } from "keplerConfigs/config/configMap";
import { getViewPointConfig } from "keplerConfigs/config/homeMap/pointsConf";
import { optionsFiltersStations } from "constants/metrics";
import { saveCluster } from "store/user.store";
import SelectZoneAndSearchComponent from "components/cards/select/SelectZoneAndSearch.component";
import CurrentDataContainer from "containers/currentData/CurrentData.container";
import { openSnackbar } from "store/slices/snackbar";
import StatusStationsCard from "components/cards/status/StatusStations.component";
import { refreshToken } from "store/user.store";
import { logout } from "store/user.store";
import { useTranslation } from "react-i18next";
import StatsContainer from "./stats/StatsCurrent.container";
import MapWithFiltersComponent from "components/kleperMap/mapFilter/MapWithFilters.component";

const optionsFilter = optionsFiltersStations;

const optionsChecked = {
  PC: false,
  advanced_point: false,
  base_point: false,
  camera: false,
  elenco_poi: true,
  gateway: false,
  wifi: false,
};
const VISITOR = "visitor";

const HomeContainer = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { token, cluster, refresh_token, user } = useSelector(
    (state) => state.user
  );
  const [zoneSelected, setZoneSelected] = useState(cluster ? cluster : []);
  const [dataStations, setDataStations] = useState([]);
  const [statusStations, setStatusStations] = useState(null);
  const [stationsCritic, setStationsCritic] = useState(null);
  const [stationsOk, setStationsOk] = useState(null);
  const [stationsWarning, setStationsWarning] = useState(null);
  const [selected, setSelected] = useState([optionsFilter[0]]);
  const [checked, setChecked] = useState(optionsChecked);
  const [config, setConfig] = useState({});
  const [listClusters, setListClusters] = useState([]);
  const [layers, setLayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allStations, setAllStations] = useState(null);
  const [isFirstRefresh, setIsFirstRefresh] = useState(true);
  const [dataFilter, setDataFilter] = useState(null);
  const [dataStationsStatus, setDataStationsStatus] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [isVisitor, setIsVisitor] = useState(true);
  const [valueSearch, setValueSearch] = useState(null);

  const filters = useMemo(
    () => [
      { title: t("all"), label: "elenco_poi" },
      { title: "Camera", label: "camera" },
      { title: "WiFi", label: "wifi" },
      { title: t("Base environmental station"), label: "base_point" },
      { title: t("Advanced environmental station"), label: "advanced_point" },
      { title: t("people-counter"), label: "PC" },
      { title: "Gateway", label: "gateway" },
    ],
    [t]
  );

  const fields = useMemo(
    () => [
      {
        name: "ID",
        type: "string",
        format: "",
        analyzerType: "STRING",
      },

      {
        name: t("Address"),
        type: "string",
        format: "",
        analyzerType: "STRING",
      },
      {
        name: "lat",
        type: "real",
        format: "",
        analyzerType: "FLOAT",
      },
      {
        name: "lon",
        type: "real",
        format: "",
        analyzerType: "FLOAT",
      },
      {
        name: 'Cluster',
        type: "string",
        format: "",
        analyzerType: "STRING",
      },
      {
        name: t("Status"),
        type: "string",
        format: "",
        analyzerType: "STRING",
      },
      isVisitor
        ? {
          name: "",
          type: "string",
          format: "",
          analyzerType: "STRING",
        }
        : {
          name: "Link",
          type: "string",
          format: "",
          analyzerType: "STRING",
        },
    ],
    [t, isVisitor]
  );

  const fieldsTooltip = useMemo(
    () => [
      {
        name: "ID",
        format: null,
      },
      {
        name: 'Cluster',
        format: null,
      },
      {
        name: t("Address"),
        format: null,
      },
      {
        name: t("Status"),
        format: null,
      },
      isVisitor
        ? {}
        : {
          name: "Link",
          format: null,
        },
    ],
    [t, isVisitor]
  );

  const onRefresh = useCallback(() => {
    setRefresh(!refresh);
  }, [refresh]);

  const handleSearch = useCallback(
    (e) => {
      const searchValue = e.target.value;
      setValueSearch(searchValue);
      const searchResult = dataStationsStatus?.filter((item) => {
        return (
          item.stationId?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.tag?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.alias?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.address?.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.cluster?.toLowerCase().includes(searchValue.toLowerCase())
        );
      });
      setDataFilter(searchResult);
    },
    [dataStationsStatus]
  );

  const handleChangeZone = useCallback((item) => {
    setZoneSelected(item);
    dispatch(saveCluster(item));
    setStatusStations([]);
    setLayers([]);
    setStationsWarning(null);

    // eslint-disable-next-line
  }, []);

  const onFailure = useCallback((error) => {
    dispatch(
      openSnackbar({
        open: true,
        message: error.response?.data?.message
          ? error.response.data.message
          : "Errore",

        variant: "alert",
        alert: {
          color: "error",
        },
        close: false,
      })
    );
    setLoading(false);
    setDataStations({ stations: [] });
    setDataFilter({ stations: [] });
    // eslint-disable-next-line
  }, []);

  const onChange = useCallback(
    (item) => {
      setDataStations(null);
      setDataFilter(null);
      setStatusStations([]);
      setLayers([]);
      if (item.name === "elenco_poi") {
        setChecked({
          [item.name]: !checked[item.name],
          PC: false,
          advanced_point: false,
          base_point: false,
          camera: false,
          gateway: false,
          wifi: false,
        });
      } else {
        // if(Object.values(checked).filter((item)=> item!==false))
        if (checked["elenco_poi"]) {
          setChecked({
            ...checked,
            elenco_poi: false,
            [item.name]: !checked[item.name],
          });
        } else {
          setChecked({
            ...checked,
            [item.name]: !checked[item.name],
          });
        }
      }
    },
    [checked]
  );

  const onError = useCallback(
    (error) => {
      if (isFirstRefresh) {
        setLoading(false);
        if (error?.response?.status === 403) {
          onLogout(error);
        } else {
          if (error?.response?.status !== 401) {
            onFailure(error);
          } else {
            if (isFirstRefresh) {
              dispatch(
                refreshToken({
                  grant_type: "refresh_token",
                  refresh_token: user.refresh_token,
                })
              );
              setIsFirstRefresh(false);
            }
          }
        }
      } else {
        onLogout(error);
      }
    },
    // eslint-disable-next-line
    []
  );

  const onLogout = useCallback((error) => {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      dispatch(logout());
    }
    // eslint-disable-next-line
  }, []);

  const createDataSets = useCallback(() => {
    let datasets = [];

    selected.map((item) => {
      datasets = _.concat(
        datasets,
        getPointStatusFields(
          statusStations?.stations,
          dataFilter,
          item?.name,
          fields,
          t("critic"),
          "OK",
          t("warning"),
          isVisitor
        )
      );
      return datasets;
    });
    return datasets;
  }, [selected, statusStations, dataFilter, fields, t, isVisitor]);

  const createViewPoints = useCallback(() => {
    const datasets = [];
    if (listClusters) {
      selected.map((filter) => {
        datasets.push(
          getViewPointConfig(
            `${filter.name}-critico`,
            t(filter.label),
            [240, 45, 3]
          )
        );
        datasets.push(
          getViewPointConfig(
            `${filter.name}-warning`,
            t(filter.label),
            [240, 197, 3]
          )
        );
        datasets.push(
          getViewPointConfig(`${filter.name}-ok`, t(filter.label), [14, 202, 8])
        );
        return filter;
      });
    }

    return datasets;
  }, [listClusters, selected, t]);

  const createInteractionConfig = useCallback(() => {
    const obj = {};
    filters.map((filter) => {
      obj[`${filter.label}-critico`] = fieldsTooltip;
      return obj;
    });

    filters.map((filter) => {
      obj[`${filter.label}-ok`] = fieldsTooltip;
      return obj;
    });

    filters.map((filter) => {
      obj[`${filter.label}-warning`] = fieldsTooltip;
      return obj;
    });

    let configInteraction = {
      tooltip: {
        fieldsToShow: obj,
        compareMode: false,
        compareType: "absolute",
        enabled: true,
      },
      brush: {
        size: 0.5,
        enabled: false,
      },
      geocoder: {
        enabled: false,
      },
      coordinate: {
        enabled: false,
      },
    };

    return configInteraction;
  }, [filters, fieldsTooltip]);

  const onSuccessStations = useCallback((resp) => {
    setDataStations(resp);
    setDataFilter(resp.stations);
    setLoading(false);
    setIsFirstRefresh(true);
    // eslint-disable-next-line
  }, []);

  const onSuccessStatus = useCallback((resp) => {
    setStatusStations(resp);
    setLoading(false);
    setIsFirstRefresh(true);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (user && user.role === VISITOR) {
      setIsVisitor(true);
    } else {
      setIsVisitor(false);
    }
  }, [user]);

  useEffect(() => {
    setLoading(true);
    Request.stations
      .allPoi({
        token: token,
      })
      .then((resp) => {
        setAllStations(resp);
        setLoading(false);
        setIsFirstRefresh(true);
      })
      .catch((error) => onError(error, "getAllPoi"));
    // eslint-disable-next-line
  }, [token, refresh_token, refresh]);

  useEffect(() => {
    if (listClusters) {
      setLayers(createViewPoints());
    }
    // eslint-disable-next-line
  }, [listClusters, t]);

  useEffect(() => {
    setSelected(
      optionsFiltersStations.filter((item) => checked[item.name] === true)
    );
    if (Object.values(checked).filter((item) => item !== false).length === 0) {
      setChecked({
        elenco_poi: true,
        PC: false,
        advanced_point: false,
        base_point: false,
        camera: false,
        gateway: false,
        wifi: false,
      });
    }
  }, [checked]);

  useEffect(() => {
    //Ottengo dalla lista delle stazioni i cluster esistenti
    if (allStations && !_.isEmpty(allStations.stations)) {
      const clusters = allStations.stations.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.cluster === value.cluster)
      );
      const list = clusters.map((item) => {
        return item["cluster"];
      });

      setListClusters(list.sort());
    }
  }, [allStations]);

  useEffect(() => {
    if (dataFilter && layers && !_.isEmpty(layers)) {
      const newConfig = configMapTheme(theme);
      newConfig.datasets = createDataSets();
      newConfig.config.visState.interactionConfig = createInteractionConfig();
      newConfig.config.visState.layers = layers;

      setConfig(newConfig);
    }
    // eslint-disable-next-line
  }, [dataFilter, selected, theme, layers]);

  useEffect(() => {
    if (Object.values(checked).filter((item) => item !== false).length !== 0) {
      setLoading(true);
      const envPath =
        checked.base_point && checked.advanced_point
          ? "&env_monitoring=true"
          : checked.base_point || checked.advanced_point
            ? `&env_monitoring=true&env_monitoring_type=${checked.base_point
              ? "base"
              : checked.advanced_point
                ? "advanced"
                : "None"
            }`
            : "";

      Request.stations
        .all({
          token: token,
          cluster: !_.isEmpty(zoneSelected) ? `cluster=${zoneSelected}&` : "",
          camera: checked.camera ? true : "None",
          gateway: checked.gateway ? true : "None",
          wifi: checked.wifi ? true : "None",
          people_counter: checked.PC ? true : "None",
          envPath: envPath,
        })
        .then((resp) => {
          onSuccessStations(resp);
        })
        .catch((error) => onError(error));

      Request.stations
        .getStatusHome({
          token: token,
          cluster: !_.isEmpty(zoneSelected) ? `cluster=${zoneSelected}&` : "",
          camera: checked.camera ? true : "None",
          gateway: checked.gateway ? true : "None",
          wifi: checked.wifi ? true : "None",
          people_counter: checked.PC ? true : "None",
          envPath: envPath,
        })
        .then((resp) => {
          onSuccessStatus(resp);
        })
        .catch((error) => onError(error));
    } else {
      setStatusStations({ stations: [] });
      setDataStations({ stations: [] });
      setDataFilter({ stations: [] });
    }
    // eslint-disable-next-line
  }, [zoneSelected, checked, token, refresh_token, refresh]);

  useEffect(() => {
    if (
      statusStations &&
      statusStations.stations &&
      !_.isEmpty(statusStations.stations) &&
      dataStations &&
      !_.isEmpty(dataStations?.stations)
    ) {
      let lengthCritic = 0;
      let lengthOk = 0;
      let lengthWarning = 0;
      let listAllStations = [];
      setLoading(true);
      if (statusStations?.stations) {
        selected.map(() => {
          return statusStations?.stations.map((station) => {
            if (
              _.includes(Object.values(station), 40) ||
              _.includes(Object.values(station), -1)
            ) {
              const obj = _.find(
                dataStations?.stations,
                (item) => item?.stationId === station?.stationId
              );
              const stationStatus = { ...obj, status: t("critic") };
              listAllStations.push(stationStatus);

              lengthCritic++;
            } else {
              if (_.includes(Object.values(station), 30)) {
                const obj = _.find(
                  dataStations?.stations,
                  (item) => item?.stationId === station?.stationId
                );
                const stationStatus = { ...obj, status: t("warning") };
                listAllStations.push(stationStatus);
                lengthWarning++;
              } else {
                const obj = _.find(
                  dataStations?.stations,
                  (item) => item?.stationId === station?.stationId
                );
                const stationStatus = { ...obj, status: "OK" };
                listAllStations.push(stationStatus);
                lengthOk++;
              }
            }

            return station;
          });
        });
      }

      setDataStationsStatus(listAllStations);
      setStationsCritic(lengthCritic);
      setStationsOk(lengthOk);
      setStationsWarning(lengthWarning);
      setLayers(createViewPoints());
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [statusStations, dataStations, t]);

  useEffect(() => {
    if (valueSearch) {
      handleSearch({ target: { value: valueSearch } });
    }
  }, [valueSearch, handleSearch, dataStations, statusStations]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SelectZoneAndSearchComponent
          listClusters={listClusters}
          handleChangeZone={handleChangeZone}
          zoneSelected={zoneSelected}
          handleSearch={handleSearch}
          loading={loading}
          onRefresh={onRefresh}
          valueSearch={valueSearch}
        />
      </Grid>
      {loading ? (
        <Grid item xs={12}>
          <Box m={5}>
            <Loading />
          </Box>
        </Grid>
      ) : (
        <Fragment>
          <Grid item xs={12}>
            <StatsContainer
              zoneSelected={zoneSelected}
              user={user}
              onError={onError}
              refresh={refresh}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={3} lg={3}>
            <StatusStationsCard
              active={stationsOk}
              allarm={stationsCritic}
              warning={stationsWarning}
            />
          </Grid>

          <Grid item xs={12} sm={8} md={9} lg={9}>
            <CurrentDataContainer
              zoneSelected={zoneSelected}
              onFailure={onFailure}
              isHome={true}
              sx={{
                border: "1px solid #E6DEB8",
                boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
              }}
            />
          </Grid>
        </Fragment>
      )}

      <Grid item xs={12}>
        <MapWithFiltersComponent
          config={config}
          options={optionsFiltersStations}
          checked={checked}
          onChange={onChange}
        />
      </Grid>
    </Grid>
  );
};

export default HomeContainer;
